import React from 'react';
import PropTypes from 'prop-types';
import {withRadium, gtmEvent} from 'higher-order-components';
import {invokeFuncs} from 'utils/function';
import {gtmButtonActionTypes} from 'store/gtm-events';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 * Hyperlink
 */
const Hyperlink = ({
                     href,
                     external,
                     pageName,
                     pcText,
                     mbText,
                     onClick,
                     gtmEvents,
                     gtmEvent,
                     gtm,
                     children,
                   }) => {
  const handleClick = (e) => {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(e);
    }
    //
    if (gtmEvents !== null && 0 <= gtmEvents.length) {
      invokeFuncs(gtmEvents);
    } else if (gtm !== null && gtm.category) {
      let buttonName = '';
      if (pcText !== null) {
        buttonName = pcText;
      } else {
        if (mbText !== null) {
          buttonName = mbText;
        }
      }
      gtmEvent({
        gtmID: gtmButtonActionTypes.CLICK_BUTTON,
        gtmPayload: {
          CMSGroupGTM: gtm,
          buttonName: buttonName,
        },
      });
    }
  };
  //
  const getPcText = () => {
    if (pcText !== null) {
      return pcText;
    }
    return (pageName !== null) ? pageName: '';
  };
  const getMbText = () => {
    if (mbText !== null) {
      return mbText;
    } else {
      if (pcText !== null) {
        return pcText;
      }
    }
    return (pageName !== null) ? pageName: '';
  };
  return (
    <a className="Hyperlink"
       href={(href !== null) ? href: ''}
       target={(external === true) ? '_blank': null}
       onClick={(e) => {
         handleClick(e)
       }}
    >
            <span className="Hyperlink__text-pc">
                <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
            </span>
      <span className="Hyperlink__text-mb">
                <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
            </span>
      {(children !== null) ? children: null}
    </a>
  )
};
Hyperlink.propTypes = {
  href: PropTypes.string,
  external: PropTypes.bool,
  pageName: PropTypes.string,
  pcText: PropTypes.string,
  mbText: PropTypes.string,
  onClick: PropTypes.func,
  gtmEvents: PropTypes.array,
  gtm: PropTypes.object,
  children: PropTypes.node,
};
Hyperlink.defaultProps = {
  href: null,
  external: null,
  pageName: null,
  pcText: null,
  mbText: null,
  onClick: null,
  gtmEvents: null,
  gtm: null,
  children: null,
};
export default withRadium(gtmEvent())(Hyperlink);



// WEBPACK FOOTER //
// ./src/components/hyperlink/index.jsx